import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SttTabs, SttFullDialog } from '../../../sporttia/all';
import BookingScheduleDetails from './BookingScheduleDetails';
import BookingScheduleBookings from './BookingScheduleBookings';
import { useCrud } from '../../../lib/hooks';
import { getPath } from '../../Pages';
import constants from '../../../config/constants';

type BookingScheduleType = {
    id?: string;
    name?: string;
    trash?: number;
};

export default function BookingSchedule(): React.ReactElement {
    const { t } = useTranslation();
    const { id } = useParams<{ id: string }>();
    const [bookings, setBookings, , Get] = useCrud<any>();
    const [bookingSchedule, setBookingSchedule] = useState<
        BookingScheduleType | undefined
    >();
    const navigate = useNavigate();

    function loadBookings(params = { page: 1, rows: 20 }) {
        let scheduleId = id;
        if (!scheduleId) scheduleId = bookingSchedule?.id;
        if (scheduleId !== constants.gui.objectState.create) {
            Get(`/bookings/schedules/${scheduleId}/bookings`, {
                ...params,
            }).then(setBookings);
        }
    }

    // Load bookingSchedule from API
    function loadBookingSchedule() {
        Get(`/bookings/schedules/${id}`, {
            trash: true,
        }).then((response) => {
            const { bookingSchedule: bookingScheduleRes } = response as {
                bookingSchedule: BookingScheduleType;
            };
            setBookingSchedule(bookingScheduleRes);
        });
    }

    useEffect(() => {
        if (id !== 'create') {
            loadBookings();
            loadBookingSchedule();
        }
    }, [id]);

    const tabs = [
        {
            caption: t('Detail'),
            component: (
                <BookingScheduleDetails
                    id={id}
                    trash={bookingSchedule?.trash}
                    onSaveSlot={loadBookings}
                    bookingScheduleInit={bookingSchedule}
                    onSaveBookingSchedule={(
                        pickedBookingSchedule: BookingScheduleType,
                    ) => setBookingSchedule(pickedBookingSchedule)}
                />
            ),
        },
        {
            caption: t('Bookings'),
            component: (
                <BookingScheduleBookings
                    onFetch={
                        loadBookings as (
                            params?: unknown,
                        ) => Promise<unknown> | void
                    }
                    bookings={bookings}
                />
            ),
            show: id !== 'create',
        },
    ];

    return (
        <SttFullDialog
            open={!!(bookingSchedule?.id || id === 'create')}
            onClose={() => navigate(getPath('bookingSchedules'))}
            title={
                bookingSchedule ? bookingSchedule.name : t('newBookingSchedule')
            }
            urlPath={
                id !== 'create' && id ? `/booking/schedules/${id}` : undefined
            }
        >
            <SttTabs tabs={tabs} />
        </SttFullDialog>
    );
}
